// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let PrescriptionV1Api = class PrescriptionV1Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param accountId generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    async accountPrescriptionGet(accountId, xTcScopeid, xTcScopetype) {
        const _url_ = '/prescription/v1/AccountPrescription/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPrescriptionGet.');
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param ndcCode generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    async code(ndcCode, xTcScopeid, xTcScopetype) {
        const _url_ = '/prescription/v1/NdcCode';
        let _params_ = {};
        let _headers_ = {};
        if (ndcCode !== undefined) {
            _params_['ndcCode'] = Serializer.serialize(ndcCode, "string");
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param ndcId generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    async id(ndcId, xTcScopeid, xTcScopetype) {
        const _url_ = '/prescription/v1/NdcId';
        let _params_ = {};
        let _headers_ = {};
        if (ndcId !== undefined) {
            _params_['ndcId'] = Serializer.serialize(ndcId, "string");
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param xProgramId The program id from the list of allowed program ids
     */
    async programIdByProgramId(xTcScopeid, xTcScopetype, xProgramId) {
        const _url_ = '/prescription/v1/NdcprogramId';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
};
PrescriptionV1Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], PrescriptionV1Api);
export { PrescriptionV1Api };
//# sourceMappingURL=prescriptionV1Api.js.map